import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import InstaTable from './InstaTable'

import {
  busers_index,
  clear_buser,
  resend_b2b_invitation,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.buser
  return {
    buser: state.buser,
    busers: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getBusers: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( busers_index(page, per_page, filters, sort, order) ),
    resendInvitation: (buser_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(resend_b2b_invitation(buser_id, index, page, per_page, filters, sort, order)),
    clearBuser: () => dispatch( clear_buser() ),
    setPath: path => dispatch( set_path(path) ),
  }
}

class ConnectedBusersIndex extends React.Component {
  state={
    current_buser: null,
    current_view: 'all',
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at" ) {
      renderText = item[field] ? new Date(item[field]).toLocaleDateString() : ''
    } else if ( field === "status" ) {
      renderText = this.statusIcon(item.status)
    } else if (field === 'id' || field === 'email') {
      renderText = item[field]
    } else if (field === 'user') {
      renderText = (
        <Link to={`/users/${item.id}/edit`} className="test_results_link" title="Edit User" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.display_name}</div>
          <div className="td-user-name">{item.email}</div>
        </Link>
      )
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { this.editLink(item, state) }
          { (item.status === "pending") && this.resendLink(item, state) }
          { (item.tests > 0 ) && this.resultsLink(item) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getBusers } = this.props
    getBusers()
    this.props.setPath('b2busers')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.buser.fetching && !this.props.buser.fetching && this.props.buser.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  editLink = item => {
    const {id} = item
    return (
      <Link to ={`/users/${id}/edit`} className="action-btn" title="Edit" onClick={this.props.clearBuser}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
      </Link>
    )
  }

  resendLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Resend Invitation" onClick={e=>{
        e.preventDefault()
        this.props.resendInvitation(id, true,  page, per_page, filters, sort, order)
      }}>
      <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>mail</Icon>
      </Link>
    )
  }

  resultsLink = (item) => {
    const {email} = item
    return (
      <Link to={`/tests/user?user=${email}`} className="action-btn" title="Test Results" target="_blank">
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>insert_chart</Icon>
      </Link>
    )
  }

  hideDialog() {
    this.setState({showDialog: false, current_buser: {}})
  }

  statusIcon = status => {
    if (status === 'active') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Active">person_outline</Icon>
    } else if (status === 'locked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Locked Out">lock</Icon>
    } else if (status === 'pending') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Pending">hourglass_empty</Icon>
    } else if (status === 'revoked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Blocked">block</Icon>
    }
  }

  showPreview = item => {
    // this.setState({showPreview: true, current_template: template})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { busers, pagination, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'user', disablePadding: true, label: 'User' },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'created_at', disablePadding: true, label: 'Creation' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "created_at", filter_type: "date" },
      { name: "search", filter_type: "search" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "locked", label: "Locked", value: totals.locked },
      { name: "pending", label: "Pending", value: totals.pending },
      { name: "revoked", label: "Blocked", value: totals.revoked },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.buser.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Test Takers
          </Typography>

        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={busers}
          pagination={pagination}
          userRole={'client'}
          search={true}
          placeholders="ID, email, name"
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getBusers.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="busers"
          addClassField="status"
        />

      </div>
    )
  }
}

const BusersIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedBusersIndex)

export default withStyles(styles)(BusersIndex)



// WEBPACK FOOTER //
// ./src/js/components/B2bUsersIndex.js